import React from 'react';
import PropTypes from 'prop-types';
import { ICONS } from 'constants/icons';
import ReportDetails from './ReportDetails';
import { REPORT_TYPE_TRIAL } from '../ReservationFeedbackModalV2.constants';
import messages from '../ReservationFeedbackModalV2.messages';

const guidelines = [
  {
    icon: ICONS.checkSparkle,
    title: messages.trialAbuseGuidelineEligibilityTitle,
    description: messages.trialAbuseGuidelineEligibilityDescription,
  },
  {
    icon: ICONS.pointUp,
    title: messages.trialAbuseGuidelineVisitTitle,
    description: messages.trialAbuseGuidelineVisitDescription,
  },
  {
    icon: ICONS.invitePhones,
    title: messages.trialAbuseGuidelineSharingTitle,
    description: messages.trialAbuseGuidelineSharingDescription,
  },
];

const TrialAbuseReportDetails = ({
  fullName,
  profileUrl,
  venueId,
  reservationId,
  submitReport,
  onReported,
  setProcessingStep,
  setSuccessStep,
  resizeModal,
  failedFormValues,
  onSubmitError,
}) => (
  <ReportDetails
    fullName={fullName}
    profileUrl={profileUrl}
    reasonType={messages.trialProgramAbuse}
    guidelines={guidelines}
    venueId={venueId}
    reservationId={reservationId}
    submitReport={submitReport}
    onReported={onReported}
    reportType={REPORT_TYPE_TRIAL}
    resizeModal={resizeModal}
    setProcessingStep={setProcessingStep}
    setSuccessStep={setSuccessStep}
    failedFormValues={failedFormValues}
    onSubmitError={onSubmitError}
  />
);

TrialAbuseReportDetails.propTypes = {
  fullName: PropTypes.string,
  profileUrl: PropTypes.string,
  venueId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  reservationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  submitReport: PropTypes.func.isRequired,
  onReported: PropTypes.func,
  resizeModal: PropTypes.func,
  setProcessingStep: PropTypes.func.isRequired,
  setSuccessStep: PropTypes.func.isRequired,
  failedFormValues: ReportDetails.propTypes.failedFormValues,
  onSubmitError: PropTypes.func,
};

export default TrialAbuseReportDetails;
